/**
 * ArbiHunter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: ROOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class ManagerUpdateDTO {
    'hirerRole'?: ManagerUpdateDTOHirerRoleEnum;
    'firstName'?: string;
    'lastName'?: string;
    'patronymic'?: string;
    'position'?: string;
    'permissions'?: Array<ManagerUpdateDTOPermissionsEnum>;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "hirerRole",
            "baseName": "hirerRole",
            "type": "ManagerUpdateDTOHirerRoleEnum",
            "format": ""
        },
        {
            "name": "firstName",
            "baseName": "firstName",
            "type": "string",
            "format": ""
        },
        {
            "name": "lastName",
            "baseName": "lastName",
            "type": "string",
            "format": ""
        },
        {
            "name": "patronymic",
            "baseName": "patronymic",
            "type": "string",
            "format": ""
        },
        {
            "name": "position",
            "baseName": "position",
            "type": "string",
            "format": ""
        },
        {
            "name": "permissions",
            "baseName": "permissions",
            "type": "Array<ManagerUpdateDTOPermissionsEnum>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ManagerUpdateDTO.attributeTypeMap;
    }

    public constructor() {
    }
}

export enum ManagerUpdateDTOHirerRoleEnum {
    ADMIN = 'admin',
    MANAGER = 'manager'
}
export enum ManagerUpdateDTOPermissionsEnum {
    CHANGE_EMAIL = 'changeEmail',
    CHANGE_PASSWORD = 'changePassword',
    VIEW_STATS = 'viewStats',
    CREATE_VACANCIES = 'createVacancies',
    MANAGE_APPLICATIONS = 'manageApplications',
    EDIT_COMPANY_PROFILE = 'editCompanyProfile',
    EDIT_COMPANY_BLOG = 'editCompanyBlog'
}

